module.exports = __webpack_public_path__ + "static/media/icon_msg_orange-02.91ce4f74.svg";